import liff from "@line/liff";
import jsQR from "jsqr";

// Singleton guard — ป้องกัน liff.init() ถูกเรียกซ้ำ (จะ error "already been called")
let liffReady = null;
export const initLiff = () => {
  if (!liffReady) {
    liffReady = liff
      .init({ liffId: process.env.REACT_APP_LINE_LIFF_ID })
      .catch((err) => {
        liffReady = null; // reset เพื่อให้ retry ได้
        throw err;
      });
  }
  return liffReady;
};

/**
 * ตรวจสอบว่าอยู่ใน LIFF browser หรือไม่
 */
export const isLiffBrowser = () => {
  try {
    return liff.isInClient();
  } catch {
    return false;
  }
};

/**
 * ตรวจสอบว่าอยู่ใน LINE in-app browser หรือไม่ (รวมทั้ง LIFF และ non-LIFF)
 */
export const isLineBrowser = () => {
  return /Line/i.test(navigator.userAgent);
};

/** ย่อรูปก่อน decode — รูปจากกล้องมือถือ 12MP ทำให้ jsQR ช้ามากและกิน memory */
const MAX_DECODE_SIZE = 2000;

/**
 * อ่าน QR จากไฟล์รูป (เลือกจากคลังภาพ / ถ่ายด้วยแอปกล้อง)
 * เป็นทางออกสำรองเวลากล้องในเบราว์เซอร์โฟกัสไม่เข้า
 * เพราะแอปกล้องของเครื่องจัดการ autofocus / macro ให้เองอยู่แล้ว
 * @returns {Promise<string|null>} ข้อความใน QR หรือ null ถ้าอ่านไม่ได้
 */
export const decodeQrFromImageFile = (file) =>
  new Promise((resolve) => {
    const reader = new FileReader();

    reader.onerror = () => resolve(null);
    reader.onload = (event) => {
      const img = new Image();

      img.onerror = () => resolve(null);
      img.onload = () => {
        const scale = Math.min(
          1,
          MAX_DECODE_SIZE / Math.max(img.width, img.height),
        );
        const canvas = document.createElement("canvas");
        canvas.width = Math.round(img.width * scale);
        canvas.height = Math.round(img.height * scale);

        const ctx = canvas.getContext("2d", { willReadFrequently: true });
        ctx.drawImage(img, 0, 0, canvas.width, canvas.height);

        try {
          const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
          const code = jsQR(imageData.data, imageData.width, imageData.height);
          resolve(code?.data || null);
        } catch {
          resolve(null);
        }
      };

      img.src = event.target.result;
    };

    reader.readAsDataURL(file);
  });

